import React, { memo } from 'react'
import { HeaderLeftWrapper } from './style'
import { useNavigate } from 'react-router-dom'

const HeaderLeft = memo(() => {
  // 点击logo，跳转到首页
  const navigate = useNavigate()

  return (
    <HeaderLeftWrapper>
      <img className='logo' src={require("@/assets/img/logo.png")} alt="" onClick={e => navigate('/home')} />
    </HeaderLeftWrapper>
  )
})

export default HeaderLeft